import React, { FC, useEffect } from 'react';
import cx from 'classnames';
import { Link, ZolaAppButton } from '@zola/zola-ui';
import ZolaHeartsLogo from '@zola/zola-ui/src/assets/images/logos/zola-logo-hearts.svg';
import { trackMinimalLogoClick, detectIOS, deleteCookie } from '@zola-helpers/client';

import AppImageSrc from 'assets/images/post-onboarding/app-download@2x.png';
import sharedStyles from 'pages/postOnboard/postOnboardStyles.module.less';
import styles from './AppDownload.module.less';

interface AppDownloadProps {
  hed: string;
  deepLink?: string;
  onClick: () => void;
  asModal?: boolean;
  onSkip: () => void;
}

const AppDownload: FC<AppDownloadProps> = ({ hed, deepLink, onClick, asModal, onSkip }) => {
  const appStore = detectIOS() ? 'iOS' : 'Android';
  useEffect(function clearCookie() {
    // When we show one app download popup or screen, prevent others from hounding the user
    deleteCookie('appDownload');

    if (document?.body) {
      const orig = document.body.className;
      document.body.className = `${orig} modal-open`.trim();
    }
    const footer = document.getElementsByClassName('common-footer')[0];
    if (footer) {
      footer.className = `${footer.className} ${styles.hideForModal}`.trim();
    }

    return (): void => {
      if (document?.body) {
        document.body.className = document.body.className.replace(/ ?modal-open/g, '');
      }
      if (footer) {
        footer.className = `${footer.className}`.replace(styles.hideForModal, '');
      }
    };
  }, []);

  return (
    <div className={cx(styles.container, { [styles.modal]: asModal })}>
      <div className={sharedStyles.top}>
        <a href="/" onClick={trackMinimalLogoClick} aria-label="Zola Homepage">
          <img src={ZolaHeartsLogo} alt="Zola Hearts Logo" id="zola-ui-logo-hearts" />
        </a>
        <Link arrow className={sharedStyles.headerSkipLink} onClick={onSkip}>
          Skip
        </Link>
      </div>
      <h1 className={cx(sharedStyles.hed)}>{hed}</h1>
      <ZolaAppButton
        variant={appStore}
        deepLink={deepLink}
        className={styles.storeLink}
        onClick={onClick}
      />
      <img className={styles.appImage} src={AppImageSrc} alt="Download our 5 star app" />
    </div>
  );
};

export default AppDownload;



// WEBPACK FOOTER //
// ./src/pages/postOnboard/AppDownload/AppDownload.tsx